module.exports = __webpack_public_path__ + "images/twitter@1x.png?ce339d5d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/twitter@1x.png
// module id = 710
// module chunks = 7